
import { GoogleMyBusinessApi } from '@/api';
import PlatformDisconnectRow from '@/components/social/PlatformDisconnectRow.vue';
import { GENERIC_ERROR_DESCRIPTION } from '@/constants';
import { BotMixin } from '@/mixins/BotMixin';
import isEqual from 'fast-deep-equal/es6';
import { GoogleBusinessPlatformData, SupportedPlatform } from 'ignite360-core';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';

type GoogleMyBusinessSettings = Pick<
  GoogleBusinessPlatformData,
  'enablePosting' | 'accountId' | 'locationId'
>;

@Component({
  name: 'google-my-business-settings-card',
  components: { PlatformDisconnectRow },
})
export default class GoogleMyBusinessSettingsCard extends mixins(BotMixin) {
  @Prop({ required: false, type: Boolean, default: false })
  readonly showDisconnect!: boolean;

  googleMyBusinessSettings = this.resetValue();

  isSubmitting = false;
  isDisconnecting = false;

  get settingsHaveChanged(): boolean {
    return !isEqual(this.googleMyBusinessSettings, this.resetValue());
  }

  async onSubmit() {
    this.isSubmitting = true;
    try {
      await this.$updateBotPlatform({
        id: this.bot.id,
        platform: SupportedPlatform.GoogleBusiness,
        data: this.googleMyBusinessSettings,
      });
      this.$notify.success('Successfully updated Google-My-Business-settings');
    } catch (e) {
      this.$notify.error({
        title: 'Updating Google-My-Business-settings failed',
        description: GENERIC_ERROR_DESCRIPTION,
      });
    } finally {
      this.isSubmitting = false;
    }
  }

  async onDisconnect() {
    this.isDisconnecting = true;
    try {
      await GoogleMyBusinessApi.disconnectBotFromGoogleBusiness(this.bot.id);
      this.$emit('disconnect');
      this.$notify.success('Successfully disconnected from Google-My-Business');
    } catch (e) {
      this.$notify.error({
        title: 'Disconnecting from Google-My-Business failed',
        description: GENERIC_ERROR_DESCRIPTION,
      });
    } finally {
      this.isDisconnecting = false;
    }
  }

  @Watch('bot', { immediate: true, deep: true })
  private reset() {
    this.googleMyBusinessSettings = this.resetValue();
  }

  private resetValue(): GoogleMyBusinessSettings {
    return {
      enablePosting: this.bot.platformData.googleBusiness.enablePosting,
      accountId: this.bot.platformData.googleBusiness.accountId,
      locationId: this.bot.platformData.googleBusiness.locationId,
    };
  }
}
